import { render, staticRenderFns } from "./PershingContingentBeneficiaries.vue?vue&type=template&id=27b2fcca&scoped=true"
import script from "./PershingContingentBeneficiaries.vue?vue&type=script&lang=js"
export * from "./PershingContingentBeneficiaries.vue?vue&type=script&lang=js"
import style0 from "./PershingContingentBeneficiaries.vue?vue&type=style&index=0&id=27b2fcca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b2fcca",
  null
  
)

export default component.exports